<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_3"></a><a id="part1"></a>PART I</h2>
<p class="image1"><img alt="image" src="Images/common5.jpg"/></p>
<h2 class="h2c">Daughter of Motion<br/>
  (1988)</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?855f3840